import { render, staticRenderFns } from "./BatchMoveOverloadView.vue?vue&type=template&id=1bd9e4f5&scoped=true"
import script from "./BatchMoveOverloadView.vue?vue&type=script&lang=js"
export * from "./BatchMoveOverloadView.vue?vue&type=script&lang=js"
import style0 from "./BatchMoveOverloadView.vue?vue&type=style&index=0&id=1bd9e4f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd9e4f5",
  null
  
)

export default component.exports